<template>
  <div>
    <QuanFuPrint
      v-if="hospitalId == 11"
      :inquiryInfo="inquiryInfo"
      :_deptCode="_deptCode"
      :appMobilePhone = "appMobilePhone"
    ></QuanFuPrint>
    <LinaOuPrint
      v-else
      :inquiryInfo="inquiryInfo"
      :_deptCode="_deptCode"
      :appMobilePhone = "appMobilePhone"
    ></LinaOuPrint>
  </div>
</template>

<script>
import { GetPCOrderData } from "@/utils/api.js";
import LinaOuPrint from "@/components/print/linaOuPrint";
import QuanFuPrint from "@/components/print/quanFuPrint";
import "@/utils/jquery.jqprint-0.3";
export default {
  components: {
    LinaOuPrint,
    QuanFuPrint,
  },
  props: {
    InquiryId: {
      type: String,
      default: false,
    },
  },
  computed: {
    _deptCode: {
      get: function() {
        let code = false; //是否是中药方
        if (JSON.stringify(this.inquiryInfo) != "[]") {
          if (
            this.inquiryInfo.CNDrugsType &&
            this.inquiryInfo.CNDrugsType == 3
          ) {
            code = true;
          }
        }
        return code;
      },
    },
  },
  data() {
    return {
      inquiryInfo: [],
      sex: [],
      hospitalId: "",
      appMobilePhone: "123",
    };
  },
  methods: {
    getData() {
      let param = {
        LoInquiryId: this.InquiryId,
      };
      // const msg = this.$Message.loading({
      //   content: "获取数据中",
      //   duration: 0
      // });
      GetPCOrderData(param).then((res) => {
        // setTimeout(msg, 17);
        if (res.code == 1) {
          this.inquiryInfo = res.data;
          this.sex[0] = res.data.Sex == 2 ? "女" : "男";
          console.log(this.sex);
          this.appMobilePhone = res.data.DoctorName;
          this.hospitalId = res.data.HospitalId;
          this.$emit("afterPrint");
        } else {
          this.$Message.error("数据获取失败，请重试");
          this.$emit("beforPrint");
        }
      });
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.getData();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  deactivated() {},
};
</script>

<style lang="scss" scoped>
.domePrint {
  text-align: left;
  background: #ffffff;
  padding: 20px;
  width: 700px;
  height: 1000px;
  margin: auto;
  .rp {
    font-size: 30px;
    color: black;
    font-weight: bold;
  }
  .visibility {
    visibility: hidden;
  }
  .titleColor {
    color: black;
    font-size: 14px;
  }
  .colorBack {
    color: black;
    font-size: 18px;
  }
  .flex_d {
    width: 700px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
  }
  .flex_d_item {
    flex: 0 0 33%;
  }
  .margin-left {
    margin-left: 20px;
    // margin-right: 20px;
  }
  .data {
    padding: 8px 0px;
    .heng {
      border-bottom: 1px solid black;
    }
  }
  .widthStr280 {
    width: 280px;
  }
  .widthStr340 {
    width: 340px;
  }
  .widthStr {
    width: 300px;
  }
  .widthStr1 {
    width: 322px;
  }
  .widthStr2 {
    width: 280px;
  }
  .widthStr3 {
    width: 200px;
  }
  .widthStr4 {
    width: 250px;
  }
  .m-r {
    margin-right: 10px;
  }
  .explain {
    padding-bottom: 5px;
    border-bottom: 1px solid black;
    font-size: 15px;
    padding-left: 5px;
    position: relative;
    .imgStr_yuang {
      max-width: 160px;
      position: absolute;
      top: -270px;
      right: 165px;
    }

    .imgStr {
      max-width: 250px;
      position: absolute;
      top: -80px;
      right: 0px;
    }
  }
  .drugInfo {
    padding-bottom: 15px;
    border-bottom: 1px solid black;
    position: relative;
    .blank {
      border-top: 1px solid black;
      width: 30%;
      margin-top: 15px;
      padding: 5px;
      text-align: center;
      margin-bottom: 100px;
      .oksize {
        position: absolute;
        right: 100px;
        bottom: 20px;
        .okName {
          position: absolute;
          top: 15px;
          left: 50px;
          color: red;
          font-weight: bold;
        }
        .okData {
          position: absolute;
          bottom: 16px;
          left: 30px;
          color: red;
          font-weight: bold;
        }
      }
    }
  }
  .posionInfo_space {
    padding-bottom: 15px;
    border-bottom: 1px solid black;
  }
  .posionInfo {
    .mtb {
      padding-top: 10px;
    }
    .lableStr {
      width: auto;
      white-space: nowrap;
    }

    .name {
      width: 100%;
      border-bottom: 1px solid black;
    }
    .tonSize {
      width: 100%;
    }
    .age {
      width: 100%;
      border-bottom: 1px solid black;
    }

    .lastTonSize {
      width: 200px;
    }
  }
  .payOff {
    display: flex;
    justify-content: space-between;
    justify-items: start;
    align-items: flex-end;
    border-bottom: 1px solid black;
    padding-bottom: 5px;
  }
  .payOff_item {
    display: flex;
    justify-items: start;
    align-items: flex-end;
    // border-bottom: 1px solid black;
    // padding-bottom: 5px;
  }
  .register {
    font-size: 12px;
    color: black;
  }
  .title {
    margin: 30px 0 10px 0;
    text-align: center;
    position: relative;
  }
  .ordinary {
    position: absolute;
    top: 0;
    right: 20px;
    font-size: 12px;
    border: 1px solid black;
    padding: 3px 5px;
    border-radius: 5px;
    .putong {
      width: 100%;
      text-align: justify;
      text-align-last: justify;
    }
  }
  .bianju {
    line-height: 80px;
  }
  .hospitalName {
    font-size: 23px;
    font-weight: bold;
  }
  .hospitalOpen {
    font-size: 29px;
    font-weight: bold;
  }
}
.isChildBackground {
  background: #c9fee0;
}
</style>
